import React, { useLayoutEffect, useState } from 'react';
import useRegionSelector from '../../../hooks/useRegionSelector';
import './styles.scss';

const RegionSelector = ({ logo, information, onMobileClick }) => {
  const { region, updateRegion, showInitialPopUp } = useRegionSelector();
  const [selectorOpen, setSelectorOpen] = useState(false);

  useLayoutEffect(() => {
    if (typeof window !== 'undefined' && window.location.pathname === '/') {
      if (showInitialPopUp) {
        handleOnOpenModal();

        if (onMobileClick && window.innerWidth <= 992) {
          onMobileClick();
        }
      } else {
        handleOnCloseModal();
      }
    }
  }, [showInitialPopUp]);

  const handleOnChangeRegion = (region) => {
    setSelectorOpen(false);

    if (onMobileClick && window.innerWidth <= 992) {
      onMobileClick();
    }

    updateRegion(region);
    document.body.style.overflow = '';
  };

  const handleOnOpenModal = () => {
    setSelectorOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleOnCloseModal = () => {
    setSelectorOpen(false);
    document.body.style.overflow = '';
  };

  return (
    <>
      <div className="region-selector" onClick={handleOnOpenModal}>
        <svg
          className="default"
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="34"
          viewBox="0 0 33 34"
          fill="none"
        >
          <path
            d="M16.4376 0.5C25.5282 0.5 33 7.84717 33 16.9376C33 26.028 25.5282 33.5 16.4376 33.5C7.3469 33.5 0 26.0282 0 16.9376C0 7.8469 7.34717 0.5 16.4376 0.5ZM19.5508 3.36413C21.0452 5.6056 22.1659 7.97175 22.7884 10.3378H28.7658C26.8979 6.72655 23.5356 4.23588 19.5508 3.36413ZM29.8867 12.8282H23.4113C23.5358 13.8245 23.6603 14.9452 23.6603 16.0658C23.6603 17.6847 23.4113 19.4282 23.1622 21.1715H29.8868C30.2604 19.8016 30.5094 18.4319 30.5094 16.9376C30.5094 15.5677 30.2604 14.0734 29.8868 12.8282H29.8867ZM28.766 23.6621H22.4149C21.6677 25.9036 20.6715 28.2698 19.1773 30.7602C23.2866 29.8885 26.7736 27.2735 28.766 23.6621ZM13.8228 30.7602C12.3284 28.2696 11.2077 25.9034 10.5852 23.6621H4.23407C6.10203 27.2735 9.71344 29.8884 13.8228 30.7602ZM3.11344 21.1715H9.83801C9.4644 19.4281 9.33991 17.6848 9.33991 16.0658C9.33991 14.9451 9.46441 13.8244 9.58891 12.8282H3.11349C2.73987 14.0735 2.49086 15.5678 2.49086 16.9376C2.49086 18.4319 2.73986 19.8017 3.11349 21.1715H3.11344ZM4.23418 10.3376H10.087C10.8341 7.9715 11.955 5.60565 13.3246 3.36385C9.46412 4.23557 6.10197 6.72627 4.2339 10.3376H4.23418ZM12.7022 10.3376H20.174C19.4269 7.84701 18.1815 5.4808 16.4381 3.23955C14.8193 5.48102 13.574 7.84718 12.7022 10.3376ZM20.7966 12.8281H12.0796C11.9551 13.8244 11.8306 14.9451 11.8306 16.0657C11.8306 17.6846 11.9551 19.4281 12.4533 21.1714H20.5476C20.9212 19.428 21.1702 17.6846 21.1702 16.0657C21.1702 14.945 21.0457 13.8242 20.7966 12.8281H20.7966ZM19.8004 23.662H13.2004C13.9475 25.779 15.0683 28.0205 16.4379 30.3866C17.9323 28.0205 19.053 25.779 19.8004 23.662Z"
            fill="#011C25"
          />
        </svg>

        <span>{region}</span>

        <svg className="default" xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
          <path d="M4.5 7.5L0.602886 0.750001L8.39711 0.75L4.5 7.5Z" fill="#011C25" />
        </svg>
      </div>

      {selectorOpen && (
        <div className="modal-region-selector">
          <img className="logo" src={logo.url} alt="Positive Money Logo" />
          <div className="close-icon" onClick={handleOnCloseModal}>
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
              <g clipPath="url(#clip0_494_4486)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.9999 21.2389L27.9568 30.1958C28.2555 30.4842 28.6554 30.6438 29.0706 30.6402C29.4857 30.6366 29.8828 30.4701 30.1764 30.1765C30.4699 29.883 30.6365 29.4859 30.6401 29.0707C30.6437 28.6556 30.4841 28.2556 30.1957 27.957L21.2388 19.0001L30.1957 10.0432C30.4841 9.74454 30.6437 9.34458 30.6401 8.92944C30.6365 8.51429 30.4699 8.11717 30.1764 7.82361C29.8828 7.53005 29.4857 7.36353 29.0706 7.35992C28.6554 7.35632 28.2555 7.51591 27.9568 7.80432L18.9999 16.7612L10.043 7.80432C9.74304 7.52304 9.34541 7.36949 8.93425 7.37616C8.52308 7.38284 8.13064 7.54922 7.83997 7.8401C7.5493 8.13098 7.3832 8.52353 7.37681 8.9347C7.37043 9.34587 7.52426 9.74339 7.80576 10.0432L16.7611 19.0001L7.80417 27.957C7.65295 28.103 7.53233 28.2778 7.44935 28.4709C7.36637 28.6641 7.32269 28.8719 7.32086 29.0821C7.31903 29.2923 7.35909 29.5008 7.43871 29.6954C7.51832 29.89 7.63588 30.0668 7.78455 30.2154C7.93321 30.3641 8.10999 30.4817 8.30458 30.5613C8.49917 30.6409 8.70766 30.681 8.91789 30.6791C9.12813 30.6773 9.33589 30.6336 9.52906 30.5506C9.72224 30.4677 9.89695 30.347 10.043 30.1958L18.9999 21.2389Z"
                  fill="#011C25"
                />
              </g>
              <defs>
                <clipPath id="clip0_494_4486">
                  <rect width="38" height="38" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <div className="content">
            <div className="text" dangerouslySetInnerHTML={{ __html: information }} />

            <div className="regions">
              <div className="item" onClick={() => handleOnChangeRegion('UK')}>
                <svg
                  className="region_icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                >
                  <mask id="mask0_766_2310" maskUnits="userSpaceOnUse" x="2" y="2" width="56" height="56">
                    <path
                      d="M58 30C58 37.4261 55.05 44.548 49.799 49.799C44.548 55.05 37.4261 58 30 58C22.5739 58 15.452 55.05 10.201 49.799C4.94999 44.548 2 37.4261 2 30C2 22.5739 4.94999 15.452 10.201 10.201C15.452 4.94999 22.5739 2 30 2C37.4261 2 44.548 4.94999 49.799 10.201C55.05 15.452 58 22.5739 58 30Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_766_2310)">
                    <path d="M0 59.9993H60V0H0V59.9993Z" fill="#356BA0" />
                    <path d="M60 21.003H36V0H24V21.003H0V39.0035H24V59.9993H36V39.0035H60V21.003Z" fill="white" />
                    <path d="M60 53.1101L6.88487 0H0V6.94892L53.0625 59.9993H60V53.1101Z" fill="white" />
                    <path d="M0 53.1101L53.1141 0H60V6.94892L6.93744 59.9993H0V53.1101Z" fill="white" />
                    <path
                      d="M60 24.7507H33.5004V0H26.4996V24.7507H0V35.2486H26.4996V59.9993H33.5004V35.2486H60V24.7507Z"
                      fill="#CA4638"
                    />
                    <path d="M60.0001 59.8289V55.0861L43.8739 39.0034H39.123L60.0001 59.8289Z" fill="#CA4638" />
                    <path d="M60 0H55.2564L36 19.2116V21.003H38.9568L60 0.00540394" fill="#CA4638" />
                    <path d="M20.8842 39.0034L0 59.8343V59.9999H4.58327L24 40.6282V39.0041H20.8842" fill="#CA4638" />
                    <path d="M0 0.0407715V4.77995L16.26 21.0031H21.0105L0 0.0407715Z" fill="#CA4638" />
                  </g>
                </svg>

                <div>
                  <h3>PositiveMoney</h3>
                  <h2>UK</h2>
                </div>
              </div>

              <div className="item" onClick={() => handleOnChangeRegion('EU')}>
                <svg
                  className="region_icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                >
                  <path
                    d="M58 30.125C58 45.658 45.464 58.25 30 58.25C14.536 58.25 2 45.658 2 30.125C2 14.592 14.536 2 30 2C45.464 2 58 14.592 58 30.125Z"
                    fill="#2980B9"
                  />
                  <path
                    d="M29.9984 12.9656L30.5023 14.5109H32.1287L30.8133 15.4678L31.3138 17.0131L29.9984 16.0595L28.6831 17.0131L29.1835 15.4678L27.8682 14.5109H29.498L29.9984 12.9656Z"
                    fill="#F1C40F"
                  />
                  <path
                    d="M22.4037 14.9878L22.9075 16.5365L24.534 16.5338L23.2186 17.4907L23.7224 19.0394L22.4071 18.0858L21.0883 19.0427L21.5922 17.4941L20.2734 16.5371H21.9032L22.4037 14.9885"
                    fill="#F1C40F"
                  />
                  <path
                    d="M16.8481 20.5366L17.3519 22.0819H18.9817L17.663 23.0388L18.1702 24.5875L16.8515 23.6306L15.5361 24.5909L16.0366 23.0422L14.7212 22.0853H16.3476L16.8481 20.5366Z"
                    fill="#F1C40F"
                  />
                  <path
                    d="M37.5761 15.0115L38.0833 16.5601L39.7097 16.5574L38.3978 17.5178L38.9016 19.0664L37.5829 18.1095L36.2675 19.0664L36.7713 17.5211L35.4492 16.5642L37.079 16.5615L37.5761 15.0129"
                    fill="#F1C40F"
                  />
                  <path
                    d="M45.0355 21.9669L43.7201 22.9238L44.2239 24.4725L42.9086 23.5155L41.5898 24.4725L42.0936 22.9238L40.7749 21.9703H42.4014L42.9052 20.4182L43.4056 21.9669H45.0355Z"
                    fill="#F1C40F"
                  />
                  <path
                    d="M47.1316 29.5851L45.8095 30.5353L46.3066 32.0839L44.9946 31.1236L43.6725 32.0738L44.1797 30.5285L42.8677 29.5682L44.4941 29.5736L45.0047 28.0283L45.5018 29.577L47.1316 29.5824"
                    fill="#F1C40F"
                  />
                  <path
                    d="M44.3489 39.3979L43.0335 38.4443L41.7148 39.4012L42.2186 37.8526L40.8999 36.899L42.5263 36.8963L43.0301 35.3477L43.534 36.8963L45.1638 36.8936L43.8451 37.8505L44.3489 39.3992"
                    fill="#F1C40F"
                  />
                  <path
                    d="M28.8183 47.0328L29.3154 45.4842L28 44.5306L29.6264 44.5279L30.1269 42.9792L30.6341 44.5246L32.2571 44.5218L30.9452 45.4822L31.4524 47.0274L30.1336 46.0773L28.8183 47.0342"
                    fill="#F1C40F"
                  />
                  <path
                    d="M21.2133 45.0211L21.7137 43.4758L20.395 42.5188H22.0248L22.5253 40.9668L23.0291 42.5155L24.6555 42.5128L23.3402 43.4697L23.8474 45.0183L22.5287 44.0648L21.2133 45.0219"
                    fill="#F1C40F"
                  />
                  <path
                    d="M38.7967 44.9872L37.4814 44.0235L36.1593 44.9771L36.6699 43.4284L35.3579 42.4681L36.9843 42.4735L37.4916 40.9282L37.9886 42.4769L39.6184 42.4796L38.2963 43.433L38.7967 44.985"
                    fill="#F1C40F"
                  />
                  <path
                    d="M12.8682 29.6155L14.4946 29.6128L14.995 28.0608L15.5022 29.6061L17.1287 29.6034L15.8167 30.5671L16.3239 32.1124L15.0052 31.1588L13.6865 32.1191L14.1869 30.5704L12.8682 29.6155Z"
                    fill="#F1C40F"
                  />
                  <path
                    d="M15.6547 39.391L16.1551 37.8423L14.8364 36.8888L16.4662 36.8861L16.9701 35.3374L17.4739 36.8861H19.1003L17.785 37.843L18.2888 39.3883L16.9701 38.4347L15.6547 39.3917"
                    fill="#F1C40F"
                  />
                </svg>

                <div>
                  <h3>PositiveMoney</h3>
                  <h2>EU</h2>
                </div>
              </div>

              <div className="item" onClick={() => handleOnChangeRegion('GLOBAL')}>
                <svg
                  className="region_icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.02192 31.0962C1.41553 15.6518 13.4641 2.62365 28.9038 2.02192C44.3482 1.41553 57.3764 13.4641 57.9781 28.9038C58.5845 44.3482 46.5359 57.3764 31.0962 57.9781C15.6518 58.5845 2.62365 46.5359 2.02192 31.0962ZM31.0309 56.2895C32.8734 56.2009 34.6646 55.8697 36.3858 55.3286C36.7216 55.1793 37.0295 55.0161 37.2954 54.8388C32.6681 48.579 26.9494 51.8815 21.9723 53.5234C23.4276 55.3566 26.6835 56.2195 29.9114 56.3268C30.2892 56.3268 30.6577 56.3082 31.0309 56.2895ZM43.9097 37.8598C44.6794 36.9222 47.2029 36.2085 47.2636 35.0471C47.2916 34.5899 47.4362 33.9089 47.4921 33.4704C47.5341 33.06 44.8053 31.8145 44.3622 31.4414C43.0468 30.3685 42.641 27.7563 41.1157 26.5995C41.0877 26.5855 41.1157 26.5296 41.1157 26.4922C39.9122 26.343 35.1077 25.5267 34.366 24.3372C34.2308 24.1273 34.2261 23.9127 34.394 23.6748C33.769 23.4323 33.4145 23.241 32.7194 22.9985C28.5073 21.5291 25.0369 24.4398 23.3157 27.1639C20.1298 32.2017 29.8228 33.1579 31.0355 34.0349C32.3043 34.9444 32.9247 41.195 33.046 43.3733C33.7037 55.0534 42.7949 39.1939 43.9097 37.8598ZM12.0321 33.9089C11.9201 33.2699 9.252 31.6093 8.86018 30.9702C7.46547 28.6893 5.04456 24.3046 6.09409 21.767C4.63408 23.395 3.72449 26.8374 3.68251 30.5038C3.68251 30.6437 3.68717 30.779 3.69184 30.9143C3.81312 33.8156 4.39152 36.591 5.36175 39.1985C6.21537 40.7845 7.39084 42.0159 8.96746 42.5897C6.69115 40.2294 12.9184 38.6528 12.0321 33.9089ZM56.2755 28.3301C56.0236 24.3186 54.8808 20.5636 53.0476 17.2611C50.4961 14.0005 46.8064 10.1756 45.3837 10.1149C43.8398 10.045 42.2258 11.5703 41.3815 11.5376C40.7752 11.5097 41.167 9.98434 39.7489 9.81641C39.1332 9.73245 35.4902 12.3026 35.2057 12.7271C34.7532 13.3801 35.5229 14.3364 35.5229 15.204C35.5229 15.2926 35.3176 15.7358 35.3176 15.7358C32.962 16.72 28.3907 17.6762 29.235 20.2044C29.2863 20.335 29.333 20.461 29.4029 20.6009C30.0606 20.363 31.9638 19.2668 32.4909 19.3041C34.4733 19.4534 38.3542 21.3192 39.8656 22.3268C41.778 23.5909 44.6467 30.2146 48.5323 29.0064C49.3346 28.7639 49.4746 27.8823 49.0734 27.1779C48.6116 26.399 49.969 26.4456 50.1556 26.6368C50.6174 27.108 54.1018 30.0373 54.7642 30.4338C55.6738 30.9842 56.1262 29.9347 56.2755 28.3301ZM11.9435 14.8775C15.1667 13.2635 14.9661 15.12 17.0138 14.6489C18.138 14.383 18.0167 13.0536 18.2266 12.2C18.4972 11.1225 23.3577 8.78088 24.5098 8.24912C25.1628 7.94126 25.7972 7.60541 26.385 7.43282C28.6846 6.7378 21.5385 11.6169 21.4265 12.312C21.2819 13.1376 21.9303 13.3988 22.6346 13.2495C24.6171 12.8484 31.2688 9.95169 33.4331 9.05609C33.8343 7.72669 32.7334 7.12962 31.6746 7.32087C31.0635 7.41883 30.723 5.58099 30.9422 5.12386C29.9114 4.41951 28.7406 3.99503 27.4905 3.78046C20.2697 4.47082 13.9352 8.05787 9.6205 13.3288C9.96568 13.7953 10.4228 14.2338 10.2782 14.7469C10.4974 14.7655 11.7522 14.9801 11.9435 14.8775ZM10.2782 14.7469C10.1523 14.7375 10.3668 14.9101 10.2782 14.7469V14.7469Z"
                    fill="#1EB48F"
                  />
                </svg>

                <div>
                  <h3>PositiveMoney</h3>
                  <h2>Global</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RegionSelector;
